<script lang="ts">
  export let firstSentence = 'Like this?';
</script>

<p class="text-gray mt-8 text-lg leading-6">
  {@html firstSentence} Consider <a class="a" href="/teach">teaching with uTheory</a>, the most
  interactive way to teach and learn music theory. Find out why
  <a class="a" rel="external" href="https://info.utheory.com/about"
    >students and teachers alike love uTheory</a
  >. Teachers, register for your <a class="a" href="/teach">free teacher account</a>. Learners, you
  can <a class="a" href="/app">start mastering music theory now</a>.
</p>
